import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3576456c&scoped=true"
import script from "./index.vue?vue&type=script&lang=jsx"
export * from "./index.vue?vue&type=script&lang=jsx"
import style0 from "./index.vue?vue&type=style&index=0&id=3576456c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3576456c",
  null
  
)

export default component.exports